import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { toast } from "react-toastify";
import { useAuthStore } from "../../redux/features/authSlice"; // Adjust the path to your auth state
import "react-toastify/dist/ReactToastify.css";
import Collapsible from "./Collapsible";
import workspaceData from "../../data/workspaceData";
import supportspaceData from "../../data/supportspaceData";
import meetingspaceData from "../../data/meetingspaceData";
import { filterPropertyAPI } from "../../services/apiServices";
import { usePropertyStore } from "../../redux/features/propertyDetailSlice";
import Modal from "../common/Modal";
import { useRedirectStore } from "../../redux/features/userRedirectSlice";
import { useTranslation, Trans } from "react-i18next";

const Calculator = () => {
  const { t, i18n } = useTranslation();
  const { updateUserRedirectState } = useRedirectStore();
  const { isLoggedin, removeLoginInfo } = useAuthStore();
  const [spaces, setSpaces] = useState([]); // To store the added spaces
  const [selectedCirculation, setSelectedCirculation] = useState(12);
  const [calculatedSize, setCalculatedSize] = useState(null);
  const [isEditingSize, setIsEditingSize] = useState(false);
  const [tempSize, setTempSize] = useState({ min: null, max: null });
  const [numOfEmployees, setNumOfEmployees] = useState();
  const percentages = [12, 15, 20]; // The available percentages
  const navigate = useNavigate();
  const [latLng, setLatLng] = useState(null);
  const [showMap, setShowMap] = useState(false);
  const [error, setError] = useState("");
  const [searchLocation, setSearchLocation] = useState("");
  const [loading, setLoading] = useState(false);
  const { propertyInfo, updatePropertyInfo } = usePropertyStore();
  const [properAddress, setProperAddress] = useState("");
  const mapRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [numberOfPeople, setNumberOfPeople] = useState();

  const OnCloseFun = (setCurrentComponent, check) => {
    setIsModalOpen(false);
  };
  console.log("numOfEmployees================", numberOfPeople);
  
  // Helper to get language-prefixed path
  const getLangPath = (path) => {
    if (i18n.language === 'en') {
      return path.startsWith('/en') ? path : '/en' + (path.startsWith('/') ? path : '/' + path);
    }
    return path;
  };

  const handleGetStarted = async () => {
    // if (!isLoggedin) {
    //   setIsModalOpen(true);
    //   return;
    // }

    if (!latLng) {
      document.getElementById("location").value = "";
      setError("Please select a valid location on the map.");
      return;
    }

    if (!latLng.latitude || !latLng.longitude) {
      setError("Location data is missing. Try selecting the location again.");
      return;
    }
    if (error) {
      return;
    }
    // navigate("/consult", { state: calculateSize });
    //call the API for filter and then stored count here
    try {
      setLoading(true);
      const payload = {
        location: { latLng: latLng, address: properAddress },
        calculatedSize: calculatedSize,
      };
      const response = await filterPropertyAPI(payload);
      if (response?.data?.statusCode == 200) {
        // setUserData(response?.data?.data);
        updatePropertyInfo({
          calculatedSize: {
            size: calculatedSize ? calculatedSize : [0, 0],
            sizeCount: response?.data.count,
          },
          location: {
            latLng: latLng,
            address: properAddress,
            locationCount: response?.data.count,
          },
          numberOfEmployees: numberOfPeople,
        });
        // navigate("/consult");
        navigate(getLangPath("/ai-chat"));
      } else if (response?.data?.statusCode == 401) {
        toast.warning(
          response?.data?.message || "Your session has been expired.",
          {
            position: "top-right",
            autoClose: 3000,
          }
        );
        updateUserRedirectState();
        removeLoginInfo();
        navigate(getLangPath("/"));
      } else {
        console.warn("error filter property in API gives 401", response);
      }
    } catch (error) {
      console.warn("error coming in filter property", error);
    } finally {
      setLoading(false);
    }
  };

  const addSpace = (type, people = null) => {
    const newSpace = { type, people };
    setSpaces([...spaces, newSpace]);
  };

  const removeSpace = (type, people) => {
    let found = false; // Track if we've already removed one
    setSpaces(
      spaces.filter((space) => {
        if (!found && space.type === type && space.people === people) {
          found = true; // Mark as found so we only remove one
          return false; // Remove this one
        }
        return true; // Keep all the others
      })
    );
  };

  const sortedSpaces = [...spaces].sort((a, b) => {
    if (a.type === b.type) {
      return b.people - a.people; // Sort by the number of people in descending order if the type is the same
    }
    return a.type.localeCompare(b.type); // Otherwise, sort by the type in alphabetical order
  });

  const calculateSize = () => {
    setIsEditingSize(false);
    let minSize = 0;
    let maxSize = 0;

    spaces?.forEach((space) => {
      const type = space.type;
      const people = space.people ? parseInt(space.people, 10) : null;
      let extraSpace = 0; // Extra space for shared amenities in a private office


      switch (type) {
        case "workspace_open_office_title":
          minSize += people * 6;
          maxSize += people * 8;
          break;
        case "workspace_private_office_title":
          if (people === 1) extraSpace = 5;
          minSize += people * 10 + extraSpace;
          maxSize += people * 15 + extraSpace;
          break;
        case "supportspace_phonebooth_title":
          minSize += people * 1.5;
          maxSize += people * 2;
          break;
        case "workspace_collaborative_space_title":
          minSize += people * 5;
          maxSize += people * 10;
          break;
        case "supportspace_meeting_title":
          minSize += people * 4;
          maxSize += people * 6;
          break;
        case "workspace_conference_room_title":
          minSize += people * 3;
          maxSize += people * 5;
          break;
        case "supportspace_boardroom_title":
          minSize += people * 5;
          maxSize += people * 7;
          break;
        case "supportspace_kitchen_title":
          minSize += 10;
          maxSize += 20;
          break;
        case "supportspace_reception_title":
          minSize += 10;
          maxSize += 15;
          break;
        case "supportspace_storage_room_title":
          minSize += 5;
          maxSize += 10;
          break;
        case "supportspace_server_room_title":
          minSize += 8;
          maxSize += 12;
          break;
        default:
          break;
      }
    });

    // Adding circulation space
    const circulationFactor = 1 + selectedCirculation / 100;
    minSize = Math.ceil(minSize * circulationFactor);
    maxSize = Math.ceil(maxSize * circulationFactor);

    setCalculatedSize([minSize, maxSize]);

    console.log("maxxminnnn", minSize, maxSize);
    

    // calculate number of area/person
    calculateAreaPerPerson(minSize, maxSize);
  };

  const handleSaveSize = () => {
    setCalculatedSize([tempSize.min, tempSize.max]);
    setIsEditingSize(false);
  };

  const handleNumberOfPeaple = () => {
    setNumberOfPeople(numOfEmployees);
    setNumOfEmployees("");
  };

  // const handleInputChangeEmployee = (e) => {
  //   const updatedValue = e.target.value;
  //   setNumOfEmployees(updatedValue);

  //   setSortedSpaces((prevSpaces) => {
  //     const updatedSpaces = prevSpaces.map((space) =>
  //       space.type === "Open Office" ? { ...space, value: updatedValue } : space
  //     );

  //     // If "Open Office" doesn't exist, add a new entry
  //     if (!prevSpaces.some((space) => space.type === "Open Office")) {
  //       updatedSpaces.push({ type: "Open Office", value: updatedValue });
  //     }

  //     return updatedSpaces;
  //   });
  // };
  // Location Search - Places API
  useEffect(() => {
    function initAutocomplete() {
      const input = document.getElementById("location");
      const autocomplete = new window.google.maps.places.Autocomplete(input, {
        componentRestrictions: { country: "ro" }, // 'ro' is the country code for Romania
      });
      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();

        if (!place.geometry) {
          // Clear the input field if no details are available
          input.value = "";
          // alert("No details available for input: '" + place.name + "'");
          setError("No details available for input");
          return;
        }

        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        setProperAddress(input.value);
        // Update the state with latitude and longitude
        setLatLng({ latitude, longitude });

        // Optionally, you can also set the input value to latitude and longitude if needed
        // input.value = `${latitude},${longitude}`;
      });
    }

    if (window.google) {
      initAutocomplete();
    } else {
      const googleScript = document.createElement("script");
      googleScript.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyAd9DtfFUBGewec4qlO1SBG9NjLO4nLu34&libraries=places`;
      window.document.body.appendChild(googleScript);
      googleScript.addEventListener("load", initAutocomplete);
    }
  }, []);

  useEffect(() => {
    if (showMap) {
      const romaniaCenter = { lat: 45.9432, lng: 24.9668 }; // Romania's approximate center

      // const map = new window.google.maps.Map(mapRef.current, {
      //   center: { lat: 0, lng: 0 },
      //   zoom: 2,
      // });

      const map = new window.google.maps.Map(mapRef.current, {
        center: romaniaCenter,
        zoom: 6,
      });
      map.addListener("click", (event) => {
        const latitude = event.latLng.lat();
        const longitude = event.latLng.lng();
        setLatLng({ latitude, longitude });

        // Reverse Geocode to get the place name (you can use Google's Geocoding API)
        // Update the input field and state variables here
        // Reverse Geocoding
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode(
          { location: { lat: latitude, lng: longitude } },
          (results, status) => {
            if (status === "OK" && results.length > 0) {
              // Find the best address (avoid Plus Codes)
              let formattedAddress = "";
              for (let i = 0; i < results.length; i++) {
                if (!results[i].formatted_address.includes("+")) {
                  formattedAddress = results[i].formatted_address;
                  break;
                }
              }

              // If no valid address is found, use the first result
              if (!formattedAddress) {
                formattedAddress = results[0].formatted_address;
              }
              setProperAddress(formattedAddress);

              // Set the input field value
              document.getElementById("location").value = formattedAddress;
            } else {
              console.error("Geocoder failed due to: ", status);
            }
          }
        );

        // Close the map popup
        setShowMap(false);
      });
    }
  }, [showMap]);

  const calculateAreaPerPerson = (minSize, maxSize) => {
    if (numberOfPeople > 0) {
      const averageSize = (minSize + maxSize) / 2;
      const areaPerPerson = averageSize / numberOfPeople;

      // Update the property info with the calculated values
      updatePropertyInfo({
        numberOfEmployees: numberOfPeople,
        employeesPerArea: areaPerPerson?.toFixed(2),
      });
    }
    return 0; // Avoid division by zero
  }
  return (
    <div className="container mx-auto max-w-7xl mt-5 mb-12" id="calculator">
      <Modal
        isOpen={isModalOpen}
        onClose={(setCurrentComponent, check) =>
          OnCloseFun(setCurrentComponent, check)
        }
      ></Modal>
      <h2 className="text-3xl font-bold text-center">
        <Trans i18nKey="calculator_heading" />
      </h2>
      <h3 className="text-center mt-1 mb-4 text-lg">
        {t("calculator_subheading")}
      </h3>
      <div className="md:flex flex-col">
        <div>
          <div className="">
            {/* <div className="text-2xl bg-red-600 text-white px-4 py-2 mr-3 rounded-full">1.</div> */}
            {/* <div className="border-l border-cyan-900 border-l-2 ml-5 border-dashed h-full"></div> */}
          </div>
          <div>
            <h2 className="text-2xl font-bold mt-2 text-cyan-900">
              {t("calculator_size_style")}
            </h2>
            <p>{t("calculator_find_ideal")}</p>

            <div>
              <div className="flex justify-between items-center cursor-pointer border-b border-cyan-900 pb-3 mt-3">
                <h2 className="text-xl font-bold">{t("calculator_num_employees")}</h2>
              </div>

              <div className="flex items-center gap-4 mt-6">
                <input
                  type="number"
                  placeholder={t("calculator_num_employees_placeholder")}
                  className="w-full border  border-[#033F5B] rounded-[40px] px-7 py-2 max-w-[51%]"
                  value={numOfEmployees ?? ""}
                  onChange={(e) => {
                    setNumOfEmployees(e.target.value);
                    // sortedSpaces.push(e.target.value);
                  }}
                />

                <button
                  className="bg-red-600 text-white px-4 py-2 flex items-center gap-1 rounded-[58px]"
                  onClick={handleNumberOfPeaple}
                >
                  {t("calculator_add")}
                  {/* <i className="fas fa-users text-xl"></i> */}
                  <i className="fa-solid fa-plus text-sm"></i>
                </button>
              </div>
            </div>

            <Collapsible
              addSpace={addSpace}
              workspaceData={workspaceData}
              defaultOpen={true}
              title={t("calculator_workspaces")}
            />
            {/* <Collapsible
              addSpace={addSpace}
              workspaceData={meetingspaceData}
              title="Meeting Spaces"
            /> */}
            <Collapsible
              addSpace={addSpace}
              workspaceData={supportspaceData}
              defaultOpen={true}
              title={t("calculator_support_spaces")}
            />
          </div>
        </div>

        {/* Number of emplopyess */}
        <div className={`flex justify-between items-center mt-1 ${"mb-3"}`}>
          <span className="text-white">
            <span className="uppercase text-sm inline-block mr-1">
              {t("calculator_num_employees")}
            </span>{" "}
            <i className="fas fa-users text-xl"></i>
            {numOfEmployees}
          </span>
          <button
            className="rounded-full w-6 h-6 flex items-center justify-center bg-white"
            // onClick={() => removeSpace(space.type, space.people)}
          >
            <span
              className="text-cyan-900 text-center"
              style={{
                fontSize: "1rem",
                position: "relative",
                bottom: 1,
              }}
            >
              x
            </span>
          </button>
        </div>

        <div>
          <div className="px-5 py-3 bg-cyan-900 mt-12">
            <h2 className="text-2xl font-bold text-white mb-2 mt-1">{t("calculator_summary")}</h2>
            <hr className="mb-2" />
            {numberOfPeople && (
              <div
                className={`flex justify-between items-center mt-1isLastOfType mb-3`}
                key={1}
              >
                <span className="text-white">
                  <span className="uppercase text-sm inline-block mr-1">
                    {t("calculator_number_of_people")}
                  </span>
                  <i className="fas fa-users text-xl mr-2 ml-1"></i>
                  {numberOfPeople}
                </span>
                <button
                  className="rounded-full w-6 h-6 flex items-center justify-center bg-white"
                  onClick={() => {
                    setNumberOfPeople("")
                  }}
                >
                  <span
                    className="text-cyan-900 text-center"
                    style={{
                      fontSize: "1rem",
                      position: "relative",
                      bottom: 1,
                    }}
                  >
                    x
                  </span>
                </button>
              </div>
            )}
            {sortedSpaces.map((space, index) => {
              const isLastOfType =
                index === sortedSpaces.length - 1 ||
                sortedSpaces[index + 1].type !== space.type;
              return (
                <div
                  className={`flex justify-between items-center mt-1 ${
                    isLastOfType ? "mb-3" : ""
                  }`}
                  key={index}
                >
                  <span className="text-white">
                    <span className="uppercase text-sm inline-block mr-1">
                      {t(space.type)}
                    </span>{" "}
                    {space.people !== null && (
                      <i className="fas fa-users text-xl"></i>
                    )}{" "}
                    {space.people}
                  </span>
                  <button
                    className="rounded-full w-6 h-6 flex items-center justify-center bg-white"
                    onClick={() => removeSpace(space.type, space.people)}
                  >
                    <span
                      className="text-cyan-900 text-center"
                      style={{
                        fontSize: "1rem",
                        position: "relative",
                        bottom: 1,
                      }}
                    >
                      x
                    </span>
                  </button>
                </div>
              );
            })}
            {spaces.length > 0 && <hr className="mt-3" />}
            <p className="text-base mt-3 text-white">
              {t("calculator_circulation_info")}
            </p>

            <div className="mt-16 flex sm:flex-row flex-col gap-3 justify-between items-center">
              <div className="flex gap-4 mt-3">
                {percentages.map((percentage, index) => (
                  <button
                    key={index}
                    className={`rounded-xl w-12 h-10 flex items-center justify-center text-cyan-900 ${
                      selectedCirculation === percentage
                        ? "bg-white"
                        : "bg-white bg-opacity-50"
                    }`}
                    onClick={() => setSelectedCirculation(percentage)}
                  >
                    {percentage}%
                  </button>
                ))}
              </div>

              <div className="flex sm:flex-row flex-col gap-4 items-center">
                <button
                  className="mt-4 min-w-[200px] mb-2 p-4 rounded-[121px] bg-cyan-900 border border-white text-white font-semibold text-lg"
                  onClick={() => setIsEditingSize(true)}
                >
                  {t("calculator_i_already_know")}
                </button>

                <button
                  className="mt-4 min-w-[200px] mb-2 p-4 rounded-[121px] bg-white text-primary-text font-semibold text-lg"
                  onClick={calculateSize}
                >
                  {t("calculator_calculate")}
                </button>
                {/* <p
                  className="mt-1 text-white cursor-pointer text-sm text-center hover:underline"
                  onClick={() => setIsEditingSize(true)}
                >
                  I already know my size requirements
                </p> */}
              </div>
            </div>
          </div>
          {(calculatedSize || isEditingSize) && (
            <div className="bg-red-600 px-5 py-3 mt-4 text-white">
              <h3 className="text-xl font-bold text-white mb-2 mt-1">
                {t("calculator_ideal_size")}
              </h3>
              <hr />
              <div className="mt-3 flex items-center">
                {isEditingSize ? (
                  <>
                    <input
                      type="number"
                      value={tempSize.min ?? ""}
                      onChange={(e) =>
                        setTempSize({ ...tempSize, min: e.target.value })
                      }
                      placeholder="100"
                      className="mr-2 max-w-16 text-cyan-900 rounded-md px-2 py-2 text-sm"
                    />
                    <span>-</span>
                    <input
                      type="number"
                      value={tempSize.max ?? ""}
                      onChange={(e) =>
                        setTempSize({ ...tempSize, max: e.target.value })
                      }
                      placeholder="200"
                      className="ml-2 max-w-16 text-cyan-900 rounded-md px-2 py-2 text-sm"
                    />
                    <button
                      onClick={handleSaveSize}
                      className="ml-4 border px-2 py-1 hover:bg-white hover:text-red-600"
                    >
                      <i className="fas fa-check"></i> {t("calculator_save")}
                    </button>
                  </>
                ) : (
                  <>
                    <p>
                      {calculatedSize[0]} - {calculatedSize[1]} m<sup>2</sup>
                    </p>
                    <button
                      onClick={() => setIsEditingSize(true)}
                      className="ml-4 px-2 py-1"
                    >
                      <i className="fas fa-pen-to-square"></i> {t("calculator_modify")}
                    </button>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="md:flex mt-6">
        <div className="w-full flex md:mr-12 md:pr-0 pr-16">
          <div className="">
            <div className="text-2xl bg-red-600 text-white px-4 py-2 mr-3 rounded-full">
              2.
            </div>
            <div className="border-l border-cyan-900 border-l-2 ml-5 border-dashed h-full"></div>
          </div>
          <div className="flex mt-2 items-center relative">
            <label htmlFor="location">{t("calculator_near_this_place")}</label>
            <div>
              <div className="relative">
                <input
                  type="text"
                  id="location"
                  placeholder={t("calculator_enter_city")}
                  className="px-3 py-1 ml-2 border-red-600 border rounded-md pl-3 pr-8 max-w-80 w-full"
                  // value={searchLocation}
                  onChange={(e) => {
                    setError("");
                    // setLocation(e.target.value);
                  }}
                />
                {/* <i
                  className="fas fa-map-location-dot absolute top-1/2 right-0 transform -translate-y-1/2 rounded-md text-red-600 border border-red-600 px-2 py-2"
                  onClick={() => setShowMap(true)}
                ></i> */}
              </div>
              <div>
                {error && (
                  <p className="text-red-600 text-sm mt-1 ml-2">{error}</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {showMap && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
        >
          <div
            style={{
              width: "80%",
              height: "80%",
              margin: "auto",
              backgroundColor: "white",
            }}
          >
            <div ref={mapRef} style={{ width: "100%", height: "100%" }}></div>
          </div>
        </div>
      )}

      {/* <div className="md:flex mt-6">
        <div className="w-full flex md:mr-12 md:pr-0 pr-16">
          <div className="">
            <div className="text-2xl bg-red-600 text-white px-4 py-2 mr-3 rounded-full">
              3.
            </div>
            <div className="border-l border-cyan-900 border-l-2 ml-5 border-dashed h-full"></div>
          </div>
          <div>
            <h2 className="text-2xl font-bold mt-2 text-cyan-900">
              Budget & Contact Information
            </h2>
            <p>You will receive offers on the contact details given below</p>
          </div>
        </div>
      </div> */}
      <div className="md:flex mt-6">
        <div className="w-full flex md:mr-12 md:pr-0 pr-16">
          <div className="">
            <div className="text-xl w-12 h-12 bg-red-600 text-white px-4 py-2 mr-3 rounded-full">
              <i className="fas fa-check relative" style={{ top: 3 }}></i>
            </div>
          </div>
          <div>
            <h2 className="text-2xl font-bold mt-2 text-cyan-900">
              {t("calculator_done")}
            </h2>
            <p className="mb-3">{t("calculator_time_to_evaluate")}</p>
            <button
              onClick={handleGetStarted}
              className="bg-red-600 rounded-full px-3 py-2 text-white"
            >
              {loading ? (
                <div className="flex">
                  <ClipLoader size={20} color="#fff" />
                </div>
              ) : (
                <>
                  {t("calculator_lets_get_started")}
                  <i className="fas fa-chevron-right"></i>
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Calculator;

// Hi @Kuldeep Choudhary ,
// I created an API you can use to get the thumbnail images. Here is the URL pattern:
// https://www.officerentinfo.{countrycode}/api/get-property-thumbnail/{propertyId}

// For example: https://www.officerentinfo.ro/api/get-property-thumbnail/15923
// It will return a JSON, under "thumbnail" key you can find the link.

// We have the following sites:
// officerentinfo.ro - Romania
// officerentinfo.pl - Poland
// officerentinfo.at - Austria
// officerentinfo.rs - Serbia
// officerentinfo.com.hr - Croatia (make sure to append .com.hr here not just .hr)
// officerentinfo.sk - Slovakia
// officerentinfo.cz - Czechia
// officerentinfo.fr - France
// officerentinfo.be - Belgium
// officerentinfo.lu - Luxembourg
